import React, { useMemo, useCallback } from "react";
import { DatePicker } from "antd";
import { getDateRangePresets, DateRange } from "../../utils/date-utils";
import { Dayjs } from "dayjs";

export interface DateSelectProps {
  label?: string;
  name?: string;
  readOnly?: boolean;
  dateRange: DateRange;
  handleDate: (dates: DateRange) => void;
  className?: string;
  
  /**
   * Whether to show a label
   */
  showLabel?: boolean;
}


const DateSelect: React.FC<DateSelectProps> = ({
  label,
  name,
  readOnly,
  dateRange,
  handleDate,
  className = "",
  showLabel = false
}) => {
  const rangePresets = useMemo(
    () => getDateRangePresets(),
    []
  );

  const onRangeChange = useCallback((dates: any) => {
    if (dates) {
      handleDate([dates[0], dates[1]]);
    }
  }, [handleDate]);

  return (
    <div className={`sm:grid sm:gap-4 sm:items-start py-3 pt-0 sm:border-gray-200 ${className}`}>
      {showLabel && label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label}
        </label>
      )}
      <DatePicker.RangePicker
        className="max-w-lg w-[400px] shadow-sm sm:max-w-xs h-[38px] border-gray-300 focus:ring-indigo-500 focus:border-indigo-500 rounded-md"
        presets={rangePresets}
        onChange={onRangeChange}
        allowClear={false}
        value={dateRange}
        disabled={readOnly}
      />
    </div>
  );
};

export default DateSelect;
